import React from 'react';
import { Box, Container, Grid, Link, Typography } from '@mui/material';
import facebookIcon from '../../../assets/facebook.svg';

const legalLinks = [
  { label: 'Terms of Use', href: '#' },
  { label: 'Privacy Policy', href: '#' },
  { label: 'Cookies Policy', href: '#' },
  { label: 'Return & Refund Policy', href: '#' },
];

const socialLinks = [
  {
    icon: <img src="https://www.sirivannavari.com/wp-content/uploads/2025/09/instagram.svg" alt="Instagram" width={22} height={22} />,
    href: 'https://www.instagram.com/sirivannavari_shop/',
    label: 'Instagram',
  },
  {
    icon: <img src={facebookIcon} alt="Facebook" width={22} height={22} />,
    href: 'https://www.facebook.com/SirivannavariBangkok',
    label: 'Facebook',
  },
  {
    icon: <img src="https://www.sirivannavari.com/wp-content/uploads/2025/08/Group-2.svg" alt="YouTube" width={22} height={22} />,
    href: 'https://www.youtube.com/@sirivannavaribangkok8396',
    label: 'YouTube',
  },
  {
    icon: <img src="https://www.sirivannavari.com/wp-content/uploads/2025/08/line_167649.png" alt="LINE" width={22} height={22} style={{ objectFit: 'contain' }} />,
    href: 'https://line.me/R/ti/p/@aqz1477b',
    label: 'LINE',
  },
];

export const AppFooter: React.FC = () => (
  <Box component="footer" sx={{ mt: 6, pt: 4, pb: 1, mb: '116px' }}>
    <Container sx={{ borderTop: '1px solid #e0e0e0', maxWidth: { xs: '95%', md: '80%' }, justifyItems: 'center' }}>
      <Grid container spacing={4} sx={{ mt: { xs: '32px', md: '80px' }, width:'100%' }}>

        {/* Legal */}
        <Grid size={{ xs: 12, md: 4 }} sx={{ justifyItems: 'start', pl: { xs: 0, md: '52px' } }}>
          <Typography variant="h6" gutterBottom sx={{ fontFamily: 'Nandia', fontSize: '24px', mb: 2, width:'80%' }}>
            Legal
          </Typography>
          {legalLinks.map(({ label, href }) => (
            <Typography key={label} variant="body2" sx={{ mb: 0.75, fontSize: '16px' }}>
              <Link href={href} underline="hover" color="#4D4D4D">
                {label}
              </Link>
            </Typography>
          ))}
        </Grid>

        {/* Social Media */}
        <Grid size={{ xs: 12, md: 4 }} sx={{ pl: '5vw' }}>
          <Typography variant="h6" gutterBottom sx={{ fontFamily: 'Nandia', fontSize: '24px', mb: 2 }}>
            Social Media
          </Typography>
          <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
            {socialLinks.map(({ icon, href, label }) => (
              <Link
                key={label}
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={label}
                color="#4D4D4D"
                sx={{ display: 'flex', '&:hover': { color: 'text.primary' } }}
              >
                {icon}
              </Link>
            ))}
          </Box>
        </Grid>

        {/* Contact */}
        <Grid size={{ xs: 12, md: 4 }} sx={{ pl: '5vw' }}>
          <Typography variant="h6" gutterBottom sx={{ fontFamily: 'Nandia', fontSize: '24px', mb: 2 }}>
            Contact
          </Typography>
          <Typography variant="body2" color="#4D4D4D" sx={{ mb: 0.25, fontSize: '16px', fontWeight: 500 }}>
            Local Sales Inquiries
          </Typography>
          <Typography variant="body2" color="#4D4D4D" sx={{ mb: 1.5, fontSize: '14px' }}>
            phiemsuk.i@sirivannavaribkk.com
          </Typography>
          <Typography variant="body2" color="#4D4D4D" sx={{ mb: 0.25, fontSize: '16px', fontWeight: 500 }}>
            International Sales Inquiries
          </Typography>
          <Typography variant="body2" color="#4D4D4D" sx={{ mb: 1.5, fontSize: '14px' }}>
            phiemsuk.i@sirivannavaribkk.com
          </Typography>
          <Typography variant="body2" color="#4D4D4D" sx={{ mb: 0.25, fontSize: '16px', fontWeight: 500 }}>
            PR Inquiries
          </Typography>
          <Typography variant="body2" color="#4D4D4D" sx={{ mb: 1.5, fontSize: '14px' }}>
            tarinee.p@sirivannavaribkk.com
          </Typography>
        </Grid>

      </Grid>

      {/* Brand + Copyright */}
      <Box sx={{ textAlign: 'center', pt: 3 }}>
        <img
          src="https://www.sirivannavari.com/wp-content/uploads/2025/07/d217d21394140e815c0d9b9fa993a7c81e54c3d1.png"
          alt="SIRIVANNAVARI"
          style={{ height: 105, objectFit: 'contain', marginBottom: 8, maxWidth: '100%' }}
        />
        <Typography variant="body2" color="#000000" sx={{ fontFamily: 'Nandia', fontSize: '16px' }}>
          © 2005-2025 Iris 2005 Co.,Ltd. All rights reserved.
        </Typography>
      </Box>
    </Container>
  </Box>
);

export default AppFooter;
